<template>
  <div class="input-popup">
    <van-popup round :style="{width: '303px'}" :value="value" @input="value => $emit('input', value)">
      <div class="common-popup-type">
        <div class="tip-str">
          <p>{{title}}</p>
        </div>
        <van-field ref="inputRef"
                   class="input"
                   v-model="inputText"
                   maxlength="10"
                   :formatter="formatter"
                   input-align="center"/>
        <div class="select-type-box clearfix">
          <div :class="['tab',activeIndex==1?'active':'']" @click="onLeftChange">{{leftTitle}}</div>
          <div :class="['tab',activeIndex==2?'active':'', disable?'disable': '']" @click="onRightChange">{{rightTitle}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant"

export default {
  name: 'inputPopup',
  props: {
    title: String,
    imgUrl:String,
    leftTitle: String,
    rightTitle: String,
    activeIndex: {
      type: Number,
      default: 1
    },
    value: Boolean
  },
  data() {
    return {
      isPageShow:false,
      inputText: '',
      disable: true
    }
  },
  watch: {
    // inputText(oldVal, newVal) {
    //   this.disable = (newVal.trim() === '')
    // }
  },
  methods: {
    formatter(value) {
      // 过滤输入的数字
      return value.replace(/[^\u4e00-\u9fa5a-zA-Z]/g,'')
    },
    setFocus() {
      this.$refs.inputRef.focus()
    },
    onLeftChange() {
      this.$emit('input', false)
      this.$emit('leftChange')
    },
    onRightChange() {
      if (this.inputText.trim() == '') {
        this.$toast.fail('请输入推荐人姓名')
        return
      }
      this.$emit('input', false)
      this.$emit('rightChange', this.inputText)
    }
  }
}
</script>

<style lang="less" scoped>
.input-popup {
  /deep/ .van-field__control {
    font-size: 20px;
    color: #3B3B3B;
  }
}
.common-popup-type {
  width: 84%;
  padding: 30px 0 30px 0;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 5px;
}
.input {
  margin-top: 10px;
}
.tip-str {
  font-size: 18px;
  font-weight: 400;
  color: #3B3B3B;
  line-height: 21px;
  text-align: center;
  display: block;
  padding: 0px 10px;
}
.select-type-box {
  width: 100%;
  margin: 0px auto;
  margin-top: 17px;
}
.tab {
  display: block;
  width: 49%;
  height: 43px;
  float: left;
  line-height: 43px;
  text-align: center;
  border-radius: 22px;
  margin-right: 2%;
  background-color: #E4E4E4;
  color: #303030;
  font-weight: 600;
}
//.disable {
//  background-color: #E4E4E4;
//  color: #e1e1e1;
//}
.tab:last-child {
  margin-right: 0%;
}
.active{
  background-color: #3377ff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/modules/inputPopup/index.vue